import web from 'src/common/constants/analytics/categoryActionLabel/web';
import {
  createEventString,
  createEventBody,
  createEventParams,
} from 'src/common/actions/logging';

export default function reportAdBlockState(tuneInApiClient, isAdBlockEnabled) {
  const eventObj = {
    category: web.category,
    action: web.actions.adblocker,
    label: isAdBlockEnabled,
  };

  const event = createEventString(eventObj);
  const body = createEventBody(event);
  const params = createEventParams();

  tuneInApiClient.logging.eventLog(params, body);
}
